import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    component: () => import('../layout/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'doctors',
        name: 'Doctors',
        component: () => import('../views/Doctors.vue'),
        meta: { title: '医生管理' }
      },
      {
        path: 'diseases',
        name: 'Diseases',
        component: () => import('../views/Diseases.vue'),
        meta: { title: '病种管理' }
      },
      {
        path: 'schedules',
        name: 'Schedules',
        component: () => import('../views/Schedules.vue'),
        meta: { title: '排班管理' }
      },
      {
        path: 'registrations',
        name: 'Registrations',
        component: () => import('../views/Registrations.vue'),
        meta: { title: '挂号记录' }
      },
      {
        path: 'patient-registrations',
        name: 'PatientRegistrations',
        component: () => import('../views/PatientRegistrations.vue'),
        meta: { title: '就诊人挂号查询' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'banners',
        name: 'Banners',
        component: () => import('../views/Banners.vue'),
        meta: { title: '首页轮播管理' }
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('../views/News.vue'),
        meta: { title: '医院动态管理' }
      },
      {
        path: 'specialties',
        name: 'Specialties',
        component: () => import('../views/Specialties.vue'),
        meta: { title: '特色专科管理' }
      },
      {
        path: 'about-content',
        name: 'AboutContent',
        component: () => import('../views/AboutContent.vue'),
        meta: { title: '关于页文案管理' }
      },
      {
        path: 'promotions',
        name: 'Promotions',
        component: () => import('../views/Promotions.vue'),
        meta: { title: '优惠活动管理' }
      },
      {
        path: 'promotion-bookings',
        name: 'PromotionBookings',
        component: () => import('../views/PromotionBookings.vue'),
        meta: { title: '优惠活动预约' }
      },
      {
        path: 'site-settings',
        name: 'SiteSettings',
        component: () => import('../views/SiteSettings.vue'),
        meta: { title: '站点配置' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
